import { useState, useEffect, useContext } from "react";
import { dataContext } from "../utils/constants";

export default function Sidebar({ isOpen, onClose, onLogout, visibleItems, setVisibleItems, handleDataUpdate, currentPageContent, openUsersEdit, openDashboard }) {
    const { user = {} } = useContext(dataContext);
    const { userRights = {}, isAdmin = 0 } = user;

    const [localVisibleItems, setLocalVisibleItems] = useState(visibleItems);

    useEffect(() => {
        if (isOpen) {
            setLocalVisibleItems(visibleItems);
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen, visibleItems]);

    const handleToggleItem = (item) => {
        setLocalVisibleItems((prev) => ({
            ...prev,
            [item]: {
                ...prev[item],
                show: !prev[item].show,
            },
        }));
    };

    const handleClose = () => {
        setVisibleItems(localVisibleItems);
        onClose();
    };

    return (
        <>
            {isOpen && <div className="overlay" onClick={handleClose}></div>}
            <div className={`sidebar d-flex flex-column p-3 text-white ${isOpen ? "open" : ""}`}>
                <button className="btn-close btn-close-white align-self-start" onClick={handleClose}></button>
                <h4 className="text-center mb-4">Налаштування</h4>

                <div className="scrollable-content">
                    {Object.keys(localVisibleItems).map((item) => {
                        if (item === "delimiter") return <div key={item} style={{ width: "100%", border: "1px solid white" }}></div>;
                        let userRightKey = `ur${item.charAt(0).toUpperCase()}${item.slice(1)}`;
                        if (item === "paymentTypesDay") userRightKey = "urPaymentTypes";
                        else if (item === "ordersStatistics") userRightKey = "urSalesReport";

                        if (userRights[userRightKey] !== 1 && isAdmin !== 1) return null;

                        return (
                            <div className="form-check form-switch my-3" key={item}>
                                <input
                                    className="form-check-input bg-secondary border-0"
                                    type="checkbox"
                                    id={item}
                                    checked={localVisibleItems[item].show}
                                    onChange={() => handleToggleItem(item)}
                                />
                                <label className="form-check-label" htmlFor={item}>
                                    {localVisibleItems[item].label}
                                </label>
                            </div>
                        );
                    })}
                </div>
                <div className="mt-auto">
                    {isAdmin === 1 && (
                        <div className="w-100 d-flex justify-content-around mb-2">
                            <button className={`btn main--button ${currentPageContent === "UsersEdit" && "w-75"}`} onClick={currentPageContent === "Dashboard" ? openUsersEdit : openDashboard}>
                                {currentPageContent === "Dashboard" ? "Редагування користувачів" : "На головну"}
                            </button>
                        </div>
                    )}

                    <div className="w-100 d-flex justify-content-between">
                        <button className="btn main--button" style={{ width: "130px" }} onClick={handleDataUpdate}>
                            Оновити дані
                        </button>

                        <button className="btn red--button" style={{ width: "130px" }} onClick={onLogout}>
                            Вихід
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
